var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4527 43.6365C23.4778 43.6365 23.6528 43.2604 23.3028 42.3325L20.4531 32.903L38.1511 21.8184L40.2259 22.3701L38.501 27.0848L24.4527 43.6365Z",
    fill: "#C8DAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5469 43.6361C25.2774 43.6361 25.594 43.281 26.0079 42.875C26.641 42.2408 34.7741 33.9955 34.7741 33.9955L29.7823 32.7271L25.1556 35.7714L24.5469 43.3824V43.6361Z",
    fill: "#A9C9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 46.575 46.575 60 30 60C13.425 60 0 46.575 0 30C0 13.425 13.425 0 30 0C46.575 0 60 13.425 60 30Z",
    fill: "url(#paint0_linear_1609_2637)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8133 36.4145L36.6968 45.3134C38.0472 46.0612 39.0293 45.6873 39.373 44.0421L44.2099 20.91C44.7009 18.8909 43.4487 17.9935 42.1474 18.5918L13.7647 29.7091C11.825 30.5068 11.8496 31.6036 13.4209 32.0772L20.713 34.3954L37.5807 23.6021C38.3663 23.1035 39.1029 23.3777 38.5137 23.9261L24.8133 36.4145Z",
    fill: "url(#paint1_linear_1609_2637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1609_2637",
    x1: 38.7925,
    y1: 9.4825,
    x2: 23.7925,
    y2: 44.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1609_2637",
    x1: 31.9314,
    y1: 31.2683,
    x2: 38.2039,
    y2: 41.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.10570ac31b62e2497a82add241681ef5.svg";
export { ForwardRef as ReactComponent };